[
  { "code": "AF", "nationality": "Afghan" },
  { "code": "AL", "nationality": "Albanian" },
  { "code": "DZ", "nationality": "Algerian" },
  { "code": "AS", "nationality": "American Samoan" },
  { "code": "AD", "nationality": "Andorran" },
  { "code": "AO", "nationality": "Angolan" },
  { "code": "AI", "nationality": "Anguillan" },
  { "code": "AG", "nationality": "Antiguan or Barbudan" },
  { "code": "AR", "nationality": "Argentine" },
  { "code": "AM", "nationality": "Armenian" },
  { "code": "AU", "nationality": "Australian" },
  { "code": "AT", "nationality": "Austrian" },
  { "code": "AZ", "nationality": "Azerbaijani" },
  { "code": "BS", "nationality": "Bahamian" },
  { "code": "BH", "nationality": "Bahraini" },
  { "code": "BD", "nationality": "Bangladeshi" },
  { "code": "BB", "nationality": "Barbadian" },
  { "code": "BY", "nationality": "Belarusian" },
  { "code": "BE", "nationality": "Belgian" },
  { "code": "BZ", "nationality": "Belizean" },
  { "code": "BJ", "nationality": "Beninese" },
  { "code": "BM", "nationality": "Bermudian" },
  { "code": "BT", "nationality": "Bhutanese" },
  { "code": "BO", "nationality": "Bolivian" },
  { "code": "BA", "nationality": "Bosnian or Herzegovinian" },
  { "code": "BW", "nationality": "Motswana" },
  { "code": "BR", "nationality": "Brazilian" },
  { "code": "BN", "nationality": "Bruneian" },
  { "code": "BG", "nationality": "Bulgarian" },
  { "code": "BF", "nationality": "Burkinabé" },
  { "code": "BI", "nationality": "Burundian" },
  { "code": "KH", "nationality": "Cambodian" },
  { "code": "CM", "nationality": "Cameroonian" },
  { "code": "CA", "nationality": "Canadian" },
  { "code": "CV", "nationality": "Cabo Verdean" },
  { "code": "CF", "nationality": "Central African" },
  { "code": "TD", "nationality": "Chadian" },
  { "code": "CL", "nationality": "Chilean" },
  { "code": "CN", "nationality": "Chinese" },
  { "code": "CO", "nationality": "Colombian" },
  { "code": "KM", "nationality": "Comoran" },
  { "code": "CG", "nationality": "Congolese" },
  { "code": "CR", "nationality": "Costa Rican" },
  { "code": "HR", "nationality": "Croatian" },
  { "code": "CU", "nationality": "Cuban" },
  { "code": "CY", "nationality": "Cypriot" },
  { "code": "CZ", "nationality": "Czech" },
  { "code": "DK", "nationality": "Danish" },
  { "code": "DJ", "nationality": "Djiboutian" },
  { "code": "DM", "nationality": "Dominican" },
  { "code": "DO", "nationality": "Dominican (Republic)" },
  { "code": "EC", "nationality": "Ecuadorian" },
  { "code": "EG", "nationality": "Egyptian" },
  { "code": "SV", "nationality": "Salvadoran" },
  { "code": "GQ", "nationality": "Equatorial Guinean" },
  { "code": "ER", "nationality": "Eritrean" },
  { "code": "EE", "nationality": "Estonian" },
  { "code": "ET", "nationality": "Ethiopian" },
  { "code": "FJ", "nationality": "Fijian" },
  { "code": "FI", "nationality": "Finnish" },
  { "code": "FR", "nationality": "French" },
  { "code": "GA", "nationality": "Gabonese" },
  { "code": "GM", "nationality": "Gambian" },
  { "code": "GE", "nationality": "Georgian" },
  { "code": "DE", "nationality": "German" },
  { "code": "GH", "nationality": "Ghanaian" },
  { "code": "GR", "nationality": "Greek" },
  { "code": "GD", "nationality": "Grenadian" },
  { "code": "GT", "nationality": "Guatemalan" },
  { "code": "GN", "nationality": "Guinean" },
  { "code": "GW", "nationality": "Bissau-Guinean" },
  { "code": "GY", "nationality": "Guyanese" },
  { "code": "HT", "nationality": "Haitian" },
  { "code": "HN", "nationality": "Honduran" },
  { "code": "HU", "nationality": "Hungarian" },
  { "code": "IS", "nationality": "Icelandic" },
  { "code": "IN", "nationality": "Indian" },
  { "code": "ID", "nationality": "Indonesian" },
  { "code": "IR", "nationality": "Iranian" },
  { "code": "IQ", "nationality": "Iraqi" },
  { "code": "IE", "nationality": "Irish" },
  { "code": "IL", "nationality": "Israeli" },
  { "code": "IT", "nationality": "Italian" },
  { "code": "JM", "nationality": "Jamaican" },
  { "code": "JP", "nationality": "Japanese" },
  { "code": "JO", "nationality": "Jordanian" },
  { "code": "KZ", "nationality": "Kazakhstani" },
  { "code": "KE", "nationality": "Kenyan" },
  { "code": "KR", "nationality": "South Korean" },
  { "code": "KW", "nationality": "Kuwaiti" },
  { "code": "KG", "nationality": "Kyrgyzstani" },
  { "code": "LA", "nationality": "Lao" },
  { "code": "LV", "nationality": "Latvian" },
  { "code": "LB", "nationality": "Lebanese" },
  { "code": "LS", "nationality": "Basotho" },
  { "code": "LR", "nationality": "Liberian" },
  { "code": "LY", "nationality": "Libyan" },
  { "code": "LT", "nationality": "Lithuanian" },
  { "code": "LU", "nationality": "Luxembourgish" },
  { "code": "MG", "nationality": "Malagasy" },
  { "code": "MW", "nationality": "Malawian" },
  { "code": "MY", "nationality": "Malaysian" },
  { "code": "MV", "nationality": "Maldivian" },
  { "code": "ML", "nationality": "Malian" },
  { "code": "MT", "nationality": "Maltese" },
  { "code": "MR", "nationality": "Mauritanian" },
  { "code": "MU", "nationality": "Mauritian" },
  { "code": "MX", "nationality": "Mexican" },
  { "code": "MD", "nationality": "Moldovan" },
  { "code": "MC", "nationality": "Monégasque" },
  { "code": "MN", "nationality": "Mongolian" },
  { "code": "MA", "nationality": "Moroccan" },
  { "code": "MZ", "nationality": "Mozambican" },
  { "code": "MM", "nationality": "Burmese" },
  { "code": "NA", "nationality": "Namibian" },
  { "code": "NP", "nationality": "Nepali" },
  { "code": "NL", "nationality": "Dutch" },
  { "code": "NZ", "nationality": "New Zealander" },
  { "code": "NI", "nationality": "Nicaraguan" },
  { "code": "NE", "nationality": "Nigerien" },
  { "code": "NG", "nationality": "Nigerian" },
  { "code": "NO", "nationality": "Norwegian" },
  { "code": "OM", "nationality": "Omani" },
  { "code": "PK", "nationality": "Pakistani" },
  { "code": "PA", "nationality": "Panamanian" },
  { "code": "PG", "nationality": "Papua New Guinean" },
  { "code": "PY", "nationality": "Paraguayan" },
  { "code": "PE", "nationality": "Peruvian" },
  { "code": "PH", "nationality": "Filipino" },
  { "code": "PL", "nationality": "Polish" },
  { "code": "PT", "nationality": "Portuguese" },
  { "code": "QA", "nationality": "Qatari" },
  { "code": "RO", "nationality": "Romanian" },
  { "code": "RU", "nationality": "Russian" },
  { "code": "RW", "nationality": "Rwandan" },
  { "code": "SA", "nationality": "Saudi" },
  { "code": "SN", "nationality": "Senegalese" },
  { "code": "RS", "nationality": "Serbian" },
  { "code": "SG", "nationality": "Singaporean" },
  { "code": "SK", "nationality": "Slovak" },
  { "code": "SI", "nationality": "Slovene" },
  { "code": "SO", "nationality": "Somali" },
  { "code": "ZA", "nationality": "South African" },
  { "code": "ES", "nationality": "Spanish" },
  { "code": "LK", "nationality": "Sri Lankan" },
  { "code": "SD", "nationality": "Sudanese" },
  { "code": "SE", "nationality": "Swedish" },
  { "code": "CH", "nationality": "Swiss" },
  { "code": "SY", "nationality": "Syrian" },
  { "code": "TW", "nationality": "Taiwanese" },
  { "code": "TJ", "nationality": "Tajikistani" },
  { "code": "TZ", "nationality": "Tanzanian" },
  { "code": "TH", "nationality": "Thai" },
  { "code": "TG", "nationality": "Togolese" },
  { "code": "TT", "nationality": "Trinidadian or Tobagonian" },
  { "code": "TN", "nationality": "Tunisian" },
  { "code": "TR", "nationality": "Turkish" },
  { "code": "TM", "nationality": "Turkmen" },
  { "code": "UG", "nationality": "Ugandan" },
  { "code": "UA", "nationality": "Ukrainian" },
  { "code": "AE", "nationality": "Emirati" },
  { "code": "GB", "nationality": "British" },
  { "code": "US", "nationality": "American" },
  { "code": "UY", "nationality": "Uruguayan" },
  { "code": "UZ", "nationality": "Uzbekistani" },
  { "code": "VE", "nationality": "Venezuelan" },
  { "code": "VN", "nationality": "Vietnamese" },
  { "code": "YE", "nationality": "Yemeni" },
  { "code": "ZM", "nationality": "Zambian" },
  { "code": "ZW", "nationality": "Zimbabwean" }
]
